import { STATUS_CODES } from '@network/error'
import { Error as ApplicationError } from '@network/error'
import {
  NotificationManager,
  NotificationTitleMessage,
} from '../NotificationsManager'

export const handleErrorNotification = (
  error: ApplicationError,
  title: NotificationTitleMessage = 'A problem occurred. Please try again.',
  forceTitle: boolean = false,
) => {
  if (error && error.code === STATUS_CODES.UNPROCESSABLE_ENTITY) {
    if (
      typeof error.validationErrors === 'string' &&
      error.validationErrors.length > 1
    ) {
      NotificationManager.error(
        error.validationErrors,
        forceTitle ? title : error.message,
      )
    } else {
      NotificationManager.error(error.message, title)
    }
  }
  if (error && error.code !== STATUS_CODES.UNPROCESSABLE_ENTITY) {
    NotificationManager.error(error.message, 'Oops, something happened!')
  }
}
